import React, { Component } from 'react';
import 'moment-timezone';
import Parser from 'html-react-parser';
import {getcustomers} from "../../../../masterData/customer/CustomerService";
import {getProjectStatuses} from "../../../project/ProjectService";

class AllocationCell extends Component {


    render() {

        let value = this.props.dataItem;

        if(value && value.ChangeRequests.length > 0){

            return <td>
                {value.ChangeRequests[0].allocEffort}
            </td>;

        }

        else{

            return <td>
                {value.allocEffort}
            </td>;
        }
    }
}

export default AllocationCell;
